import { apiFetch } from "core/api/base";

export function * getPlaygroundList () {
	return yield apiFetch({
		endpoint: "/v1/playground",
		method: "GET",
		authenticated: true
	});
}
